<template>
<div class="columns is-multiline">
    <div class="column is-full">
        <div style="color: #353b48;">Step 1: add the database server</div>
        <div style="font-size: 13px;">Add the server on which the MySQL database is running.</div>
    </div>

    <!-- <div class="column is-7">
        <div class="field">
            <input type="text" class="input custom-input-size is-medium" placeholder="Search and select and existent server" autocomplete="off" :disabled="!existentServersAreVisible"/>
            <span v-if="hasError('db_port')" class="help is-danger">{{ getError('db_port') }}</span>
        </div>
    </div>
    
    <div class="column is-1">
        <div style="display: flex; align-items: center; height: 100%; justify-content: center;">or</div>
    </div>

    <div class="column is-4">
        <div class="server-widget server-widget-hoverable-border">
            <div class="add-new-server">
                <div v-if="!addNewServerIsVisible" @click="showAddNewServer">
                    <font-awesome-icon icon="plus-circle"/>&nbsp;&nbsp;Add new server</span>
                </div>

                <div v-if="!existentServersAreVisible" @click="showExistentServers">
                    <font-awesome-icon icon="server"/>&nbsp;&nbsp;Show existent servers</span>
                </div>
            </div>
        </div>
    </div> -->

    <div class="column is-full">
        <!-- <div style="color: #353b48; margin-bottom: 8px;">Add new server</div> -->
        <add-server></add-server>
    </div>

    <div class="column is-full">
        <div style="color: #353b48; margin-bottom: 8px;">Or select an existent server</div>
        <div class="columns is-multiline">
            <!-- <div class="column is-full">
                <div class="notification" style="font-size: 13px;">
                    You don't have any existent servers. Try to add one.
                </div>
            </div> -->
            <div class="column is-4" v-for="i in 4">
                <div class="server-widget">
                    <div class="server-name">ubuntu-2gb-hel1-1</div>
                    <div class="server-host">
                        <font-awesome-icon icon="server"/>&nbsp;&nbsp;127.0.0.1
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="column is-6">
        <div class="select is-fullwidth">
            <select>
                <option>Server 1</option>
                <option>Another server</option>
            </select>
        </div>
    </div>
    <div class="column is-4">
        <div class="field">
            <input type="text" v-model="dbHost" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_host') }" class="input custom-input-size is-medium" placeholder="Database host" autocomplete="off"/>
            <span v-if="hasError('db_host')" class="help is-danger">{{ getError('db_host') }}</span>
        </div>
    </div>
    <div class="column is-2">
        <div class="field">
            <input type="text" v-model="dbPort" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_port') }" class="input custom-input-size is-medium" placeholder="Database port" autocomplete="off"/>
            <span v-if="hasError('db_port')" class="help is-danger">{{ getError('db_port') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbName" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_name') }" class="input custom-input-size is-medium" placeholder="Database name" autocomplete="off"/>
            <span v-if="hasError('db_name')" class="help is-danger">{{ getError('db_name') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbUser" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_user') }" class="input custom-input-size is-medium" placeholder="Database user" autocomplete="off"/>
            <span v-if="hasError('db_user')" class="help is-danger">{{ getError('db_user') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="password" v-model="dbPassword" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_password') }" class="input custom-input-size is-medium" placeholder="Database password" autocomplete="off"/>
            <span v-if="hasError('db_password')" class="help is-danger">{{ getError('db_password') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="password" v-model="dbPasswordConfirmation" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_password_confirmation') }" class="input custom-input-size is-medium" placeholder="Database password confirmation" autocomplete="off"/>
            <span v-if="hasError('db_password_confirmation')" class="help is-danger">{{ getError('db_password_confirmation') }}</span>
        </div>
    </div> -->
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';
import AddServer from '@/components/Servers/AddServer';

export default {
    mixins: [FormErrorsMixin],

    components: {
        AddServer,
    },

    data() {
        return {
            dbHost: '',
            dbPort: 3306,
            dbName: '',
            dbUser: '',
            dbPassword: '',
            dbPasswordConfirmation: '',
            allowedInputs: ['db_host', 'db_port', 'db_name', 'db_user', 'db_password', 'db_password_confirmation'],
            error: '',

            existentServersAreVisible: true,
            addNewServerIsVisible: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        storeDatabase() {
            Api().post('databases/mysql', this.mySQLData)
                .then(response => {
                    Event.$emit('refreshDatabaseStats', 'mysql');
                    Event.$emit('refreshDatabases', 'mysql', () => {
                        swal('Success!', 'The database was added.', 'success');
                        Event.$emit('closeAddDatabase');
                    });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.storingDatabase = false;
                });
        },

        listenEvents() {
            Event.$on('storeDatabase', () => {
                this.storeDatabase();
            });
        },

        showAddNewServer() {
            this.addNewServerIsVisible = true;
            this.existentServersAreVisible = false;
        },

        showExistentServers() {
            this.addNewServerIsVisible = false;
            this.existentServersAreVisible = true;
        },
    },

    computed: {
        mySQLData() {
            return {
                db_host: this.dbHost,
                db_port: this.dbPort,
                db_name: this.dbName,
                db_user: this.dbUser,
                db_password: this.dbPassword,
                db_password_confirmation: this.dbPasswordConfirmation,
            }
        },
    },
}
</script>
